export const URL_API_SEARCH = 'https://www.metaweather.com/api/location/search/'
export const URL_API = 'https://www.metaweather.com/api/location/'
export const URL_PROXY = 'https://api.allorigins.win/raw?url='
